import { grey } from "designSystem/styles/color";
import { ColorSpec } from "designSystem/components/colorchip/ColorChipArrayStore";
import { Box, ColorChipArray, Text } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import blackImage from "./Black.jpg";
import blueImage from "./Blue.jpg";
import greenImage from "./Green.jpg";
import greyImage from "./Grey.jpg";
import redImage from "./Red.jpg";
import silverImage from "./Silver.jpg";
import yellowImage from "./Yellow.jpg";

const colors: ColorSpec[] = [
	{
		name: "No Image",
	},
	{
		name: "Blue",
		image: blueImage,
	},
	{
		name: "Black",
		image: blackImage,
	},
	{
		name: "Grey",
		image: greyImage,
	},
	{
		name: "Silver",
		image: silverImage,
	},
	{
		name: "Red",
		image: redImage,
	},
	{
		name: "Green",
		image: greenImage,
	},
	{
		name: "Yellow",
		image: yellowImage,
	},
];

for (let i = 0; i < colors.length; i++) {
	colors[i].id = i.toString();
}

export default () => {
	const [selected, setSelected] = useState<ColorSpec>(null);
	const [hovered, setHovered] = useState<ColorSpec>(null);
	const name = useLocale()
		.resource("DefaultColor");

	const onMouseLeaveChip = (chip?: ColorSpec) => {
		if (chip) {
			console.log(`leaving ${chip.name}`);
		} else {
			console.log("called when component re-rendered");
		}
	};

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="trigger" />
			<Text semiBold text="observer" />
			<Box
				bgcolor={grey[100]}
				border={STANDARD_BORDER_STYLE}
				display="inline-block"
				p={2}
				width={250}
			>
				<ColorChipArray
					colors={colors}
					defaultColor={{ name }}
					onMouseEnterChip={setHovered}
					onMouseLeaveChip={onMouseLeaveChip}
					onSelectChip={setSelected}
					value={selected}
				/>
			</Box>
			<Box
				bgcolor={grey[100]}
				border={STANDARD_BORDER_STYLE}
				display="inline-block"
				p={2}
				width={150}
			>
				<ColorChipArray
					colors={colors}
					value={hovered}
				/>
			</Box>
		</CssColumnGrid>
	);
};